// extracted by mini-css-extract-plugin
export default {"root":"AuthorLink_root__Fe5wu","avatar":"AuthorLink_avatar__5IgXm","info":"AuthorLink_info__Cpiz6","author":"AuthorLink_author__f6fXW","link":"AuthorLink_link__Qh6Ng"};